import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  if (!component) {
    return null;
  }
  return React.createElement(component, finalProps);
};

const PrivateRoute = ({ component, authenticated, ...rest }) => (
  <Route
    render={props =>
      (authenticated ? (
        renderMergedProps(component, props, rest)
      ) : (
        <Redirect
          to={{
            pathname: '/account/login',
            state: { from: props.location },
          }}
        />
      ))
    }
    {...rest}
  />
);

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
});

export default connect(mapStateToProps)(PrivateRoute);

export const PropsRoute = ({ component, ...rest }) => (
  <Route
    {...rest}
    render={routeProps => renderMergedProps(component, routeProps, rest)}
  />
);



// WEBPACK FOOTER //
// ./foody/src/routes/PrivateRoute.jsx